import * as icons from 'react-bootstrap-icons';
import GetAppointmentStatus from "Utils/Helpers/AppointmentStatus";
import { TextShow } from 'Utils/Helpers/TextShow';
import StatusDelete from './DeleteStatus';
import GetAppointmentTime from 'Utils/Helpers/AppointmentTime';
import StatusEdit from './EditStatus';

export default function StatusShow({ data, item, close, patient, index, noChange }) {
    return (
        <div className='status-infos-dialog'>
            <div className='infos'>
                <div className='inner'>
                    <div>
                        <TextShow
                            title={'تاریخ نوبت :'}
                            icon={<icons.CaretDown size={16} className='ms-1'/>}
                            data={<GetAppointmentTime id={item.time} date={item.date} status={item.stid} inDate/>}
                        />
                        {
                            (item.toDate && item.toDate !== '') &&
                            <TextShow
                                title={'تاریخ بعدی :'}
                                icon={<icons.CaretUp size={16} className='ms-1'/>}
                                data={<GetAppointmentTime id={item.time} date={item.toDate} status={item.stid} outDate/>}
                            />
                        }
                    </div>
                    <div>
                        <TextShow
                            title={'وضعیت نوبت :'}
                            icon={<icons.ArrowLeftRight size={16} className='ms-1'/>}
                            data={<GetAppointmentStatus id={item.stid} />}
                        />
                        <TextShow
                            title={'کاربر ایجاد :'}
                            icon={<icons.Person size={16} className='ms-1'/>}
                            data={item.creatingUser}
                        />
                    </div>
                </div>
                {
                    (item.description && item.description !== '') &&
                    <div className='inner-description'>
                        <TextShow
                            title={'توضیحات :'}
                            icon={<icons.JournalCheck size={16} className='ms-1'/>}
                            // className2={'text-right bg-dark'}
                            data={item.description}
                        />
                    </div>
                }
            </div>
            {
                !noChange && (!patient && item.stid !== 0) &&
                <div className='actions'>
                    {
                        (item.status_id !== data.lastStatus_id || index !== 0) &&
                        data.lastStatus !== 5 &&
                        <StatusDelete key={`status_delete_${item.status_id}`} data={data} item={item} close={close} />
                    }
                    {
                        (item.status_id === data.lastStatus_id && index === 0) &&
                        data.lastStatus !== 5 &&
                        <StatusEdit key={`status_edit${item.status_id}`} data={data} item={item} close={close} />
                    }
                </div>
            }
        </div>
    );
}